// import * as Localization from 'expo-localization';
// import { I18n } from 'i18n-js';

// Set the key-value pairs for the different languages you want to support.
export const translations = {
    en: {
        label: "English",
        web: {
            header: "AMFY",

        },
        language: {
            en: {name: 'English'},
            ru: {name: 'Russian'}
        },
        theme: {
            turquoise: {name: 'Turquoise'},
            turquoiseLight: {name: 'Turquoise for Phone'},
            turquoiseDark: {name: 'Turquoise-Dark'},
            sandNew: {name: 'Sand Retro'}
        },
        error: {
            http: "Unexpected http error: ",
            errorPage1: "Oops...",
            errorPage2: "Something went wrong",
        },
        productCategory: {
            HEALTH: {
                name: "Health and Fitness",
                description: "- Fitness clubs and gyms.\n- Yoga studios and yoga instructors.\n- Massage salons and spa services.\n- Personal trainers.",
            },
            MEDICAL: {
                name: "Medical and Health Services",
                description: "- General practice clinics and family doctors.\n- Dental clinics and services of dentists.\n- Medical centers for children and adults.\n- Physiotherapists and rehabilitation services.",
            },
            // CAFE: {
            //     name: "Restaurants and Cafes",
            //     description: "- Restaurants with various cuisines (Italian, Chinese, Japanese, etc.).\n- Cafes and coffee shops.\n- Fast food and food delivery.",
            // },
            EDUCATION: {
                name: "Education and Training",
                description: "- Tutoring services and courses.\n- Language schools and courses.\n- Professional training courses.",
            },
            FUN: {
                name: "Entertainment and Culture",
                description: "- Cinemas and theaters.\n- Museums and exhibitions.\n- Attractions and entertainment centers.",
            },
            ELECTRONIC: {
                name: "Electronics and Technology",
                description: "- Repair and maintenance of gadgets.\n- Sale of electronics and computer equipment.",
            },
            TRAVEL: {
                name: "Travel and Tourism",
                description: "- Travel agencies and hotel booking.\n- Airline tickets and train tickets.",
            },
            HOME: {
                name: "Home and Family",
                description: "- Cleaning and home care services.\n- Repair and construction services.\n- Laundry services.",
            },
            FASHION: {
                name: "Fashion and Clothing",
                description: "- Clothing and footwear stores.\n- Swiss tailors and craft workshops.",
            },
            INFO: {
                name: "Information Services",
                description: "- Advertising agencies and marketing services.\n- Legal consultations.",
            },
            AUTO: {
                name: "Car service",
                description: "- Auto repair shops.\n- Tire services.",
            },
            BEAUTY: {
                name: "Beauty",
                description: "- Beauty salons.\n- Cosmetologist.",
            },
            OTHER: {
                name: "Other",
                description: "- Everything that does not fit into the other categories.",
            },
        },
        weekDays: [
            {name: 'Monday', short: 'Mon'},
            {name: 'Tuesday', short: 'Tue'},
            {name: 'Wednesday', short: 'Wed'},
            {name: 'Thursday', short: 'Thu'},
            {name: 'Friday', short: 'Fri'},
            {name: 'Saturday', short: 'Sat'},
            {name: 'Sunday', short: 'Sun'},
        ],
        months: [
            {name: 'January', short: 'Jan'},
            {name: 'February', short: 'Feb'},
            {name: 'March', short: 'Mar'},
            {name: 'April', short: 'Apr'},
            {name: 'May', short: 'May'},
            {name: 'June', short: 'Jun'},
            {name: 'July', short: 'Jul'},
            {name: 'August', short: 'Aug'},
            {name: 'September', short: 'Sep'},
            {name: 'October', short: 'Oct'},
            {name: 'November', short: 'Nov'},
            {name: 'December', short: 'Dec'},
        ],

        // providerType: {
        //     SINGLE: 'Одиночка',
        //     TIRE_FITTING: 'Шиномонтаж',
        //     BARBERSHOP: 'Парикмахерская',
        //     REPAIR_SHOP: 'Мастерская',
        //     BEAUTY_SALON: 'Салон красоты',
        // },
        provider: {
            addTitle: 'Добавление поставщика',
            editTitle: 'Редактирование поставщика',
            name: 'Наименование поставщика',
        },
        register: {
            fieldShouldBeNotBlank: 'Field should be not blank',
            signWithGoogle: 'Sign in with Google',
            email: 'Email',
            phone: 'Phone',
            password: 'Password',
            restorePassword: 'Restore password',
            enterEmail: 'Enter your email',
            registerTextButton: 'Create account',
            registerButton: 'Create account',
            matchingPassword: 'Repeat password',
            showPassword: 'Show password',
            hidePassword: 'Hide password',
            firstName: 'First name',
            lastName: 'Last name',
            loginText: 'Login',
            loginButton: 'Login',
            sendCode: 'Send verification code',
            resendCode: 'Resend code',
            register: 'Register',
            registration: 'Registration',
            alreadyHaveAcc: 'Already have an account?',
            forgotEmail: "Forgot email?",
            verification: "Verification",
            newPassword: "New\npassword",
            confirmButton: 'Confirm',
            registrationStep1: 'Email',
            registrationStep2: 'Email\nConfirmation',
            registrationStep3: 'Registration\ndata',
            codeFailRecieve: 'Code was not received?',
            updatePassword: 'Update password',
            updatePasswordButton: 'Set new password',
            updatePasswordOldPassword: "Old password",
            updatePasswordNewPassword: "New password",
            updateEmailStep1: 'Email',
            updateEmailStep2: 'Email\nConfirmation',
            updateEmailStep3: 'Set new\nemail',
            updateEmail: 'Update email',
            updateEmailEnterNewEmail: 'Enter new email',
            updateEmailButton: 'Set new email',
            accessDeniedPleaseLogin: 'Access denied, please login',
        },
        security: {
            verifyButton: 'Verify',
            deleteAccount: {
                info: {
                    title: "Delete your AMFY account",
                    intro: "Use this page to permanently delete your AMFY account and associated data.",
                    howItWorksTitle: "How it works:",
                    howItWorks: [
                        "Confirm your password once again.",
                        "Confirm that you want to delete your account.",
                        "Enter the one-time code we send to your email.",
                    ],
                    dataTitle: "What happens to your data:",
                    dataText: "All personal information linked to your account (name, email, phone number, photos) is permanently anonymized within 7 days of your request. Anonymized booking records may be retained for statistical and legal purposes and can no longer be connected to you.",
                },
                step1: {
                    title: "Verification"
                },
                step2: {
                    title: "Are you sure?",
                    verificationCheckbox: "I understand that account deletion is permanent and cannot be undone.",
                    proceedDeleteButton: 'Proceed',
                },
                step3: {
                    title: "Deletion",
                    deleteAccountButton: 'Delete my account',
                },
                deletedMessage: "Your account has been deleted.",
                sendCode: "Send deletion code",
                resendCode: "Resend deletion code",
                resendCodeAfter: "Resend deletion code after",
            }
            //todo Записать бы сюда что то из Register, а то получается какая то фигня неразумная...
        },
        appBarMenu: {
            logout: 'Logout',
        },
        mainMenu: {
            owner: 'Owner',
            master: 'Master',
            admin: 'Administrator',
        },
        notification: {
            cancelButton: 'Close',
            navigateButton: 'OK',
        },
        addOrganisation: {
            nameOfOrganisation: 'Name of organisation',
            // typeOfOrganisation: 'Type',
            category: 'Category',
            cityOfOrganisation: 'City',
            addressOfOrganisation: 'Address',
            emailOfOrganisation: 'Email of organisation',
            contactNumberOfOrganisation: 'Contact number',
            descriptionOfOrganisation: 'Description',
            add: 'Add',
            save: 'Save',
        },
        ownerProviderView: {
            cityOfOrganisation: 'City:',
            addressOfOrganisation: 'Address:',
            emailOfOrganisation: 'Email:',
            contactNumberOfOrganisation: 'Contact number:',
            descriptionOfOrganisation: 'Description:',
            operationsButton: 'Services',
            mastersButton: 'Employees',
            appBarEdit: 'Edit organization',
            appBarDelete: 'Delete organization',
            appBarAddEmployee: 'Add employee',
            deleteConfirmTitle: 'Are you sure?',
            deleteConfirmText: 'Delete current organization?',
            deleteConfirmButton: 'Delete',
        },
        ownerHome: {
            appbarTitle: 'List of organisations',
            emptyList: 'There is nothing here yet. But you can add an organisation.',
        },
        ownerOperationList: {
            appbarTitle: 'List of services',
            emptyList: 'There is nothing here yet. But you can add a service.',
        },
        ownerPersonList: {
            appbarTitle: 'List of employees',
            emptyList: 'There is nothing here yet. But you can invite a person.',
            administrator: 'Administrator',
        },
        ownerOperationEdit: {
            appbarTitleAdd: '',
            appbarTitleEdit: '',
            add: 'Add',
            save: 'Save',
            namePlaceholder: 'Name of service',
            pricePlaceholder: 'Price',
            timePlaceholder: 'Duration',
            descriptionPlaceholder: 'Description',
        },
        ownerOperationView: {
            appbarTitle: '',
            priceLabel: 'Price:',
            timeLabel: 'Duration:',
            descriptionLabel: 'Description:',
            appBarEdit: 'Edit service',
            appBarDelete: 'Delete service',
            deleteConfirmText: 'Delete current service?',
            deleteConfirmButton: 'Delete',
        },
        confirmationDialog: {
            cancelButton: 'Cancel',
            confirmButton: 'Confirm',
        },
        homeView: {
            appbarTitle: '',
        },
        addEmployeeView: {
            appbarTitle: '',
            pageHeader: 'Add employee',
            text: 'Tell this code to your future employee so they can join your company',
            regenerateCodeButton: 'Regenerate code',
            becomeEmployeeText: 'If you want to become employee in this organization just press button below',
            becomeEmployeeButton: 'Become employee',
        },
        clientHomeView: {
            appbarTitle: '',
            emptyList: 'There is nothing here yet.',
            appBarBecomeEmployee: 'Become employee',
            appBarBecomeOwner: 'Become Owner',
            selectCity: 'Select city',
            search: 'Search',
            upcomingAppointments: 'Upcoming Appointments',
            coolOrganizationsForYou: 'Popular organizations in your city',
            categories: 'Categories',
        },
        clientProviderSearch: {
            appbarTitle: 'Search',
            emptyList: 'There is nothing here. Please type a name of an organization in the search bar.',
        },
        clientProviderView: {
            appbarTitle: 'Organisation details',
            rating: 'Rating',
            masters: 'Masters',
            clients: 'Clients',
            addAppointment: 'Make an appointment',
        },
        clientMasterView: {
            appbarTitle: 'Master details',
            rating: 'Rating',
            reviews: 'Reviews',
            clients: 'Clients',
            addAppointment: 'Make an appointment',
        },
        clientOperationView: {
            appbarTitle: 'Operation details',
            rating: 'Rating',
            reviews: 'Reviews',
            addAppointment: 'Make an appointment',
            priceLabel: 'Price:',
            timeLabel: 'Duration:',
        },
        clientAppointmentEdit: {
            appbarTitleAdd: 'Add Appointment',
            appbarTitleEdit: 'Edit Appointment',
            servicePlaceholder: 'Service',
            masterPlaceholder: 'Any Master',
            datePlaceholder: 'Date',
            wishesPlaceholder: 'Wishes',
            selectServicePlaceholder: 'Please select a service',
            noMasterAvailablePlaceholder: 'No masters available :/',
            availableMastersLabel: 'Available masters',
            confirmButton: 'MAKE AN APPOINTMENT',
            confirmDialogMaster: 'Master',
            confirmDialogStartTime: 'Start time',
            confirmDialogEndTime: 'End time',
            confirmDialogTitle: 'Appointment details',
            error: {
                operation: 'You should select service first',
                employee: 'You should select master first',
                startTime: 'You should select time first',
                date: 'You should select date first',
            }
        },
        clientAppointmentView: {
            appbarTitle: 'Appointment\'s details',
            appbarTitleMany: 'Your appointments',
            appbarTitleEdit: 'Edit Appointment',
            organizationLabel: 'Organization:',
            serviceLabel: 'Service:',
            masterLabel: 'Master:',
            durationLabel: 'Duration:',
            priceLabel: 'Price:',
            wishesLabel: 'Wishes:',
            deleteButton: 'Cancel appointment',
            confirmDialogTitle: 'Are you sure',
            confirmDialogText: 'Cancel current appointment?',
        },
        clientSettingsView: {
            appbarTitle: 'My account',
            appbarSettings: 'Settings',
            phoneLabel: 'Phone',
            phoneLabelAdd: 'Add phone number',
            emailLabel: 'Email',
            passwordLabel: 'Change password',
            dateOfBirthLabel: 'Date of birth',
            genderLabel: 'Gender',
            paymentLabel: 'Payment',
            accountLabel: 'Account',
            logoutButtonLabel: 'Log out',
            deleteAccountButtonLabel: 'Delete account',
            deleteAccountWarningTitle: 'Delete account',
            deleteAccountWarningButtonConfirm: 'Delete',
            deleteAccountWarningText: 'Are you sure? \nThat action can not be undone.',
            settingsLabel: 'Settings',
            languageLabel: 'Language',
            themeLabel: 'Theme',
            cityLabel: 'City',
            firstName: 'First name',
            lastName: 'Last name',
            preferences: 'Preferences',
            calendar: 'Calendar',
            security: 'Security',
            notifications: 'Notifications',
            pushNotifications: 'Push notifications',
            smsNotifications: 'SMS notifications',
            emailNotifications: 'Email notifications',
            upcomingReminder: 'Upcoming reminder',
            minutesBefore: '{n} min before',
            emailFallback: "Email me if a push can't be delivered",
            emailFallbackHelp: "In the rare case a notification can't reach your device, we'll email it to you instead.",
            firstWeekDayLabel: 'First day of the week',
            generalLabel: 'General',
            saveButtonLabel: 'Save',
            notificationsImportanceType: {
                IMMEDIATE: "Immediate actions notifications",
                UPCOMING: "Upcoming appointment reminder",
                EARLY: "Early appointment reminder",
                SYSTEM: "System notifications",
                INFO: "Informational notifications"
            }
        },
        gender: {
            MALE: {
                name: "Male",
            },
            FEMALE: {
                name: "Female",
            },
            OTHER: {
                name: "Prefer not to say",
            },
        },
        firstWeekDay: {
            sunday: {
                name: "Sunday",
            },
            monday: {
                name: "Monday",
            },
        },
        becomeEmployeeView: {
            appbarTitle: 'Become an employee',
            // pageHeader: 'Become an employee',
            step1: 'Select an\norganization',
            step2: 'Became an\nemployee',
            emptyListOnEmptySearch: 'There is nothing here. Please type a name of an organization you are going to join.',
            emptyList: 'There is nothing here. Please change search name.',
            text: "Enter the code you've got from the company and press Confirm",
            confirmButton: 'Confirm',
            EMPLOYEE: 'Master',
            ADMIN: 'Administrator'
        },
        employeeHomeView: {
            appbarTitle: '',
            emptyList: 'There is nothing here yet. You have to join an organization.',
            becomeEmployeeButton: 'Become employee',
        },
        employeePersonView: {
            appbarTitle: 'Master details',
            priceLabel: 'Price:',
            timeLabel: 'Duration:',
            descriptionLabel: 'Description:',
            appBarEdit: 'Edit details',
            appBarDelete: 'Delete master',
            deleteConfirmText: 'Delete current master?',
            deleteConfirmButton: 'Delete',
            scheduleButton: 'Schedule',
            rating: 'Rating',
            reviews: 'Reviews',
            clients: 'Clients',
        },
        employeeAccountSettings: {
            work: 'Work',
        },
        employeePersonEdit: {
            appbarTitleEdit: '',
            save: 'Save',
            jobTitlePlaceholder: 'Job title',
            descriptionPlaceholder: 'Description',
            emptyOperationList: 'You must select a service or set "all services" switch'
        },
        employeeOperationList: {
            appbarTitle: 'Select services',
            emptyList: 'There is nothing here yet. But you can add a service.',
            allOperations: 'All services',
        },
        adminHomeView: {
            appbarTitle: '',
            emptyList: 'There is nothing here yet. You have to join an organization.',
            becomeEmployeeButton: 'Become employee',
        },
        adminPersonView: {
            appbarTitle: 'Admin details',
            // priceLabel: 'Price:',
            // timeLabel: 'Duration:',
            // descriptionLabel: 'Description:',
            appBarEdit: 'Edit details',
            appBarDelete: 'Delete administrator',
            deleteConfirmText: 'Delete current administrator?',
            deleteConfirmButton: 'Delete',
            // scheduleButton: 'Schedule',
            // rating: 'Rating',
            // reviews: 'Reviews',
            // clients: 'Clients',
        },
        adminPersonEdit: {
            appbarTitleEdit: '',
            save: 'Save',
            jobTitleDefault: 'Administrator',
            // jobTitlePlaceholder: 'Job title',
            // descriptionPlaceholder: 'Description',
            // emptyOperationList: 'You must select a service or set "all services" switch'
        },

        horizontalOperationList: {
            addButton: 'Add',
        },
        expandingText: {
            buttonShowMore: 'Show more',
            buttonShowLess: 'Show less',
        },
        horizontalAppointmentList: {
            emptyListTitle: "You don't have any appointments yet",
        },
        horizontalProvidersForYouList: {
            emptyListTitle: "There are no organizations in your city yet",
        },
        horizontalMasterList: {
            addButton: 'Add',
        },
        calendar: {
            appbarTitle: 'Schedule',

            navigateToDay: 'Day',
            navigateToWeek: 'Week',
            navigateToMonth: 'Month',
            navigateToYear: 'Year',
            navigateToSchedule: 'Schedule',
            emptyList: 'There is nothing here yet.',

            addSchedule: 'Add schedule',
            editSchedule: 'Edit Schedule',
            addRest: 'Add rest hours',
            editRest: 'Edit rest hours',
            restBlockInCalendar: 'Break',
            addAppointment: 'Add appointment',
            editAppointment: 'Edit appointment',
            cancelButton: 'Cancel',
            addButton: 'Add',
            saveButton: 'Save',
            deleteConfirmButton: 'Delete',

            // scheduleStartLabel: 'Start time',
            // scheduleEndLabel: 'Finish time',
            scheduleStartPlaceholder: 'Start time',
            scheduleStartError: 'Please enter start time',
            scheduleEndPlaceholder: 'Finish time',
            scheduleEndError: 'Please enter finish time',
            scheduleTimeError: 'Finish time should be grater than start time',
            deleteScheduleConfirmText: 'Delete schedule?',

            deleteRestConfirmText: 'Delete rest hours?',

            clientNamePlaceholder: 'Client name',
            clientNameError: 'Please enter client name',
            clientPhonePlaceholder: 'Client phone',
            clientEmailPlaceholder: 'Client email',
            operationPlaceholder: 'Operation',
            operationError: 'Please select operation',
            commentPlaceholder: 'Comment',
            deleteAppointmentConfirmText: 'Delete appointment?',
            durationPlaceholder: 'Duration',

        },

        settings: "Settings",
        next: "Next",
        role_user_label: 'User',
        role_owner_label: 'Owner',
        role_admin_label: 'Admin',
        role_employee_label: 'Employee',

    },
    ru: {
        label: "Русский",
        language: {
            en: {name: 'Английский'},
            ru: {name: 'Русский'}
        },
        theme: {
            turquoise: {name: 'Бирюзовая'},
            turquoiseLight: {name: 'Бирюзовая для телефона'},
            turquoiseDark: {name: 'Бирюзовая-Темная'},
            sandNew: {name: 'Песочная Ретро'}
        },
        productCategory: {
            HEALTH: {
                name: "Здоровье и Фитнес",
                description: "- Фитнес-клубы и тренажерные залы.\n- Йога-студии и йога-инструкторы.\n- Массажные салоны и спа-услуги.\n- Персональные тренеры.",
            },
            MEDICAL: {
                name: "Медицинские и Здоровьесберегающие Услуги",
                description: "- Клиники общей практики и семейные врачи.\n- Стоматологические клиники и услуги стоматологов.\n- Медицинские центры для детей и взрослых.\n- Физиотерапевты и реабилитационные услуги.",
            },
            CAFE: {
                name: "Рестораны и Кафе",
                description: "- Рестораны с разными кухнями (итальянская, китайская, японская и т.д.).\n- Кафе и кофейни.\n- Фаст-фуд и доставка еды.",
            },
            EDUCATION: {
                name: "Образование и Обучение",
                description: "- Репетиторские услуги и курсы.\n- Языковые школы и курсы.\n- Курсы по профессиональной подготовке.",
            },
            FUN: {
                name: "Развлечения и Культура",
                description: "- Кинотеатры и театры.\n- Музеи и выставки.\n- Аттракционы и развлекательные центры.",
            },
            ELECTRONIC: {
                name: "Электроника и Техника",
                description: "- Ремонт и обслуживание гаджетов.\n- Продажа электроники и компьютерной техники.",
            },
            TRAVEL: {
                name: "Путешествия и Туризм",
                description: "- Турагентства и бронирование гостиниц.\n- Авиабилеты и билеты на поезда.",
            },
            HOME: {
                name: "Дом и Семья",
                description: "- Услуги по уборке и домашний уход.\n- Ремонт и строительные услуги.\n- Услуги по прачечной.",
            },
            FASHION: {
                name: "Мода и Одежда",
                description: "- Магазины одежды и обуви.\n- Швейцарские ателье и ремесленные мастерские.",
            },
            INFO: {
                name: "Информационные Услуги",
                description: "- Рекламные агентства и услуги маркетинга.\n- Юридические консультации.",
            },
            AUTO: {
                name: "Авто",
                description: "- Автомастерсикие.\n- Шиномонтаж.",
            },
            BEAUTY: {
                name: "Красота",
                description: "- Салоны красоты.\n- Мастер - косметолог.",
            },
            OTHER: {
                name: "Прочее",
                description: "- Все, что не входит в остальные категории.",
            },
        },
        clientSettingsView: {
            appbarTitle: 'Мой профиль',
            phoneLabel: 'Телефон',
            emailLabel: 'Email',
            dateOfBirthLabel: 'Дата рождения',
            genderLabel: 'Пол',
            paymentLabel: 'Платежи',
            accountLabel: 'Аккаунт',
            logoutButtonLabel: 'Выйти',
            deleteAccountButtonLabel: 'Удалить аккаунт',
            settingsLabel: 'Настройки',
            languageLabel: 'Язык',
            cityLabel: 'Город',
            firstName: 'Имя',
            lastName: 'Фамилия',
            preferences: 'Предпочтения',
            calendar: 'Календарь'
        },
    }
};


// const i18n = new I18n(translations);

// // Set the locale once at the beginning of your app.
// i18n.locale = Localization.locale;
// // When a value is missing from a language it'll fallback to another language with the key present.
// i18n.enableFallback = true;

// if (i18n.get("email") == null) {
//     i18n.locale = "en"  // default is "en"
// }


// export function getValueByPath(obj, path) {
//     const pathParts = path.split('.'); // Split the path into parts
//     let value = obj;

//     for (const part of pathParts) {
//         if (value && typeof value === 'object' && part in value) {
//             value = value[part];
//         } else {
//             return undefined; // Path not found
//         }
//     }

//     return value;
// }

// // get localizated text
// export default function txt(msg) {
//     if (isBlank(msg)) return '';
//     // const ret = i18n.get(msg);
//     const ret = getValueByPath(translations, "en." + msg);
//     if (ret == null) {
//         return msg;
//     } else {
//         return ret;
//     }
// }

// // get localizated text
// export function translate(object, value, mn) {
//     if (isBlank(value)) return '';
//     if (isBlank(mn)) mn = 'name';
//     const msg = `${object}.${value}.${mn}`;
//     // const ret = i18n.get(msg);
//     return getValueByPath(translations, "en." + msg) || '';
// }



